import React from 'react';
import { Header as AntHeader } from 'antd/es/layout/layout';
import classNames from 'classnames';
import vantrustLogo from '../../../assets/images/logos/vantrust_logo.svg';
import useMobileBreakpoint from '../../../hooks/useMobileBreakpoint';
import './styles.less';

const Header = () => {
  const isMobile = useMobileBreakpoint();

  const className = classNames('header', {
    'header--sm': isMobile,
  });

  const logoHeight = isMobile ? 26 : 36;

  return (
    <AntHeader className={className}>
      <img alt="Logo VanTrust" src={vantrustLogo} height={logoHeight} className="header__logo" />
    </AntHeader>
  );
};

export default Header;
